import { useState, useCallback } from 'react'
import { traceMeter } from '../api/topology.ts'
import type { TraceResult } from '../types/topology.ts'
import { friendlyError } from '../utils/friendlyError.ts'

// Phase 1C: the trace response now embeds every geometry the overlay needs
// (meter/transformer/substation locations, feeder route, the real path segments,
// the ordered devices), so ONE request replaces the pre-1C 5 round trips. The
// wrapper is kept so MapPage's runTrace/clearTrace contract and MapView's
// `traceData` prop are unchanged.
export interface FullTraceData {
  trace: TraceResult
}

export function useTrace() {
  const [data, setData] = useState<FullTraceData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const runTrace = useCallback(async (meterId: number) => {
    setLoading(true)
    setError(null)
    try {
      const trace = await traceMeter(meterId)
      setData({ trace })
    } catch (err) {
      setError(friendlyError(err, 'run the trace'))
    } finally {
      setLoading(false)
    }
  }, [])

  const clearTrace = useCallback(() => {
    setData(null)
    setError(null)
  }, [])

  return { data, loading, error, runTrace, clearTrace }
}
